import type { DocumentPageMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'

function nonemptyClassification(
  value: string | null | undefined
): string | undefined {
  if (value === undefined || value === null) return undefined
  const trimmed = value.trim()
  return trimmed === '' ? undefined : trimmed
}

/** Original corpus Type; legacy events may only have a saved snapshot. */
export function generatedPageClassificationOrValuesFallback(
  edit: DocumentPageMetadataUserEditEntry
): string | undefined {
  const generated = nonemptyClassification(
    edit.entry.data.generated_values?.page_classification
  )
  if (generated !== undefined) return generated
  return nonemptyClassification(edit.entry.data.values?.page_classification)
}

/** Explicitly clearing Type must not restore the pipeline's classification. */
export function savedPageClassificationOrGeneratedFallback(
  edit: DocumentPageMetadataUserEditEntry
): string | undefined {
  const saved = edit.entry.data.values?.page_classification
  return nonemptyClassification(
    saved === undefined
      ? edit.entry.data.generated_values?.page_classification
      : saved
  )
}

export function matchesPageClassificationFilter(
  pageClassification: string | undefined,
  pageClassifications: readonly string[] | undefined
): boolean {
  if (pageClassifications === undefined) return true
  if (pageClassifications.length === 0) return false
  if (pageClassification === undefined) return false
  return pageClassifications.includes(pageClassification)
}
